import { IonContent, Platform, NavController } from '@ionic/angular';
import { Component, OnInit, ElementRef, ViewChild, Input, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format.pipe';
import { LimitsService } from 'src/app/services/limits/limits.service';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { TimeValidator } from './time.validator';

@Component({
    selector: 'page-set-time-limits',
    templateUrl: './set-time-limits.component.html',
    styleUrls: ['./set-time-limits.component.scss']
})
export class SetTimeLimitsComponent implements OnInit, AfterViewInit {
    @Input() previousPage: string = "";
    @ViewChild(IonContent, { static: false }) content: IonContent;

    @ViewChild('currentDailyLimit', {read: ElementRef}) currentDailyLimit: ElementRef;
    @ViewChild('currentWeeklyLimit', {read: ElementRef}) currentWeeklyLimit: ElementRef;
    @ViewChild('currentMonthlyLimit', {read: ElementRef}) currentMonthlyLimit: ElementRef;
    @ViewChild('timeDailyDelete', {read: ElementRef}) timeDailyDelete: ElementRef;
    @ViewChild('timeWeeklyDelete', {read: ElementRef}) timeWeeklyDelete: ElementRef;
    @ViewChild('timeMonthlyDelete', {read: ElementRef}) timeMonthlyDelete: ElementRef;
    @ViewChild('dailyRolloverPeriod', {read: ElementRef}) dailyRolloverPeriod: ElementRef;
    @ViewChild('dailyRolloverPeriodContent', {read: ElementRef}) dailyRolloverPeriodContent: ElementRef;
    @ViewChild('weeklyRolloverPeriod', {read: ElementRef}) weeklyRolloverPeriod: ElementRef;
    @ViewChild('weeklyRolloverPeriodContent', {read: ElementRef}) weeklyRolloverPeriodContent: ElementRef;
    @ViewChild('monthlyRolloverPeriod', {read: ElementRef}) monthlyRolloverPeriod: ElementRef;
    @ViewChild('monthlyRolloverPeriodContent', {read: ElementRef}) monthlyRolloverPeriodContent: ElementRef;
    @ViewChild('dailyRemoved', {read: ElementRef}) dailyRemoved: ElementRef;
    @ViewChild('dailyRemovedContent', {read: ElementRef}) dailyRemovedContent: ElementRef;
    @ViewChild('weeklyRemoved', {read: ElementRef}) weeklyRemoved: ElementRef;
    @ViewChild('weeklyRemovedContent', {read: ElementRef}) weeklyRemovedContent: ElementRef;
    @ViewChild('monthlyRemoved', {read: ElementRef}) monthlyRemoved: ElementRef;
    @ViewChild('monthlyRemovedContent', {read: ElementRef}) monthlyRemovedContent: ElementRef;
    @ViewChild('dailyTimeAmountUsed', {read: ElementRef}) dailyTimeAmountUsed: ElementRef;
    @ViewChild('dailyTimeAmountUsedContent', {read: ElementRef}) dailyTimeAmountUsedContent: ElementRef;
    @ViewChild('weeklyTimeAmountUsed', {read: ElementRef}) weeklyTimeAmountUsed: ElementRef;
    @ViewChild('weeklyTimeAmountUsedContent', {read: ElementRef}) weeklyTimeAmountUsedContent: ElementRef;
    @ViewChild('monthlyTimeAmountUsed', {read: ElementRef}) monthlyTimeAmountUsed: ElementRef;
    @ViewChild('monthlyTimeAmountUsedContent', {read: ElementRef}) monthlyTimeAmountUsedContent: ElementRef;
    @ViewChild('dailyNewLimitEffective', {read: ElementRef}) dailyNewLimitEffective: ElementRef;
    @ViewChild('dailyNewLimitEffectiveContent', {read: ElementRef}) dailyNewLimitEffectiveContent: ElementRef;
    @ViewChild('weeklyNewLimitEffective', {read: ElementRef}) weeklyNewLimitEffective: ElementRef;
    @ViewChild('weeklyNewLimitEffectiveContent', {read: ElementRef}) weeklyNewLimitEffectiveContent: ElementRef;
    @ViewChild('monthlyNewLimitEffective', {read: ElementRef}) monthlyNewLimitEffective: ElementRef;
    @ViewChild('monthlyNewLimitEffectiveContent', {read: ElementRef}) monthlyNewLimitEffectiveContent: ElementRef;
    @ViewChild('dailyPendingLimit', {read: ElementRef}) dailyPendingLimit: ElementRef;
    @ViewChild('dailyPendingLimitContent', {read: ElementRef}) dailyPendingLimitContent: ElementRef;
    @ViewChild('weeklyPendingLimit', {read: ElementRef}) weeklyPendingLimit: ElementRef;
    @ViewChild('weeklyPendingLimitContent', {read: ElementRef}) weeklyPendingLimitContent: ElementRef;
    @ViewChild('monthlyPendingLimit', {read: ElementRef}) monthlyPendingLimit: ElementRef;
    @ViewChild('monthlyPendingLimitContent', {read: ElementRef}) monthlyPendingLimitContent: ElementRef;

    public error = null;

    public timeLimitForm: FormGroup;

    public time_limit: AbstractControl;

    public timeLimits: any[] = [];

    public globalDailyLimit: any;

    public globalLimits: any[] = [];

    public totalDailyLoginTime: string | number;
    public totalWeeklyLoginTime: string | number;
    public totalMonthlyLoginTime: string | number;

    public hours: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

    public isMobile:boolean = false;

    public labels: SiteContentInterface;


    constructor(
        private siteContentService: SiteContentService,
        private configService: ConfigService,
        private responsibleGamingProvider: ResponsibleGamingService,
        public successMessageProvider: SuccessMessageService,
        private platform:Platform,
        public navCtrl: NavController,
        public utils: UtilsService,
        public dateFormatPipe: DateFormatPipe,
        public limitsService: LimitsService
        ) {

        this.detectMobile();
        this.labels = new SiteContentModel();
        this.successMessageProvider.clearMessage();
        this.error = null;
    }

    ngAfterViewInit(){
      this.siteContentService.loadConfig('time_limit')
        .then((response: SiteContentInterface) => {
            this.labels = response
        });
    }
    ngOnInit() {
      const allowThreeDigitHours = true
        this.timeLimitForm = new FormGroup(
            {
                time_limit: new FormControl('', [Validators.pattern('^[0-9]*')]),
                daily_limit: new FormControl('', [TimeValidator.timeFormat(), TimeValidator.maxTime(24, 0)]),
                weekly_limit: new FormControl('', [TimeValidator.timeFormat(allowThreeDigitHours), TimeValidator.maxTime(168, 0)]),
                monthly_limit: new FormControl('', [TimeValidator.timeFormat(allowThreeDigitHours), TimeValidator.maxTime(744, 0)]),
            },  this.atLeastOneFieldValidator
        );

        this.time_limit = this.timeLimitForm.get('time_limit');

        this.getGlobalLimits();
        this.getTotalLoginTime();
    }

    detectMobile() {
        if (this.platform.is('mobile')) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }

    getGlobalLimits() {
         this.responsibleGamingProvider.getGlobalLimits().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.globalLimits = response.payload.filter((limit) => {
                        return limit.limitType == "TIME";
                    });

                    this.globalLimits.forEach((limit) => {
                        if (limit.limitTermType == "DAILY") {
                            this.globalDailyLimit = limit;
                            this.time_limit.setValidators([Validators.pattern('^[0-9]*'), Validators.max(this.globalDailyLimit.currentLimit)]);
                        }
                    });
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    getTotalLoginTime() {
        this.responsibleGamingProvider.getTotalLoginTime(this.configService.getClientApp()).subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    if (0 <= parseInt(response.payload.time)) {
                        this.totalDailyLoginTime = this.secondsToTime(parseInt(response.payload["time-spent-daily"]));
                        this.totalWeeklyLoginTime = this.secondsToTime(parseInt(response.payload["time-spent-weekly"]));
                        this.totalMonthlyLoginTime = this.secondsToTime(parseInt(response.payload["time-spent-monthly"]));
                    }
                    this.getTimeLimits();
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    secondsToTime(seconds: any) {
        let h: string | number = Math.floor(seconds / 3600);
        let m: string | number = Math.floor((seconds - (h * 3600)) / 60);
        let s: string | number = seconds - (h * 3600) - (m * 60);
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        return `${h}:${m}:${s}`;
    }

    minutesToTime(minutes: number) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
    }

    getTimeLimits() {
        let tempLimits: any[] = [];

        this.responsibleGamingProvider.getTimeLimit().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    tempLimits = response.payload;
                    for (const index in tempLimits) {
                        if (tempLimits[index].limitSource != "GLOBAL") {
                          if (tempLimits[index].currentLimitTermType == "DAILY") {
                            tempLimits[index].cumulativeLimitValue = this.totalDailyLoginTime;
                          } else if (tempLimits[index].currentLimitTermType == "WEEKLY") {
                            tempLimits[index].cumulativeLimitValue = this.totalWeeklyLoginTime;
                          } else if (tempLimits[index].currentLimitTermType == "MONTHLY") {
                            tempLimits[index].cumulativeLimitValue = this.totalMonthlyLoginTime;
                          }
                            this.timeLimits.push(tempLimits[index]);
                        }
                    }

                    this.updateTimeLimits(this.timeLimits);
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    updateTimeLimits(timeLimits: any[]) {
        const config = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION;
        // Reset all limits to default state
        this.currentDailyLimit.nativeElement.innerHTML = "(No limit set)";
        this.currentWeeklyLimit.nativeElement.innerHTML = "(No limit set)";
        this.currentMonthlyLimit.nativeElement.innerHTML = "(No limit set)";

        // Hide all delete buttons by default
        this.timeDailyDelete.nativeElement.style.display = "none";
        this.timeWeeklyDelete.nativeElement.style.display = "none";
        this.timeMonthlyDelete.nativeElement.style.display = "none";
        timeLimits.forEach(limit => {

            if (limit && limit.currentLimitTermType) {
                switch(limit.currentLimitTermType) {
                    case "DAILY":
                        if (limit.currentLimit) {
                            this.currentDailyLimit.nativeElement.innerHTML = this.minutesToTime(limit.currentLimit);
                            this.timeDailyDelete.nativeElement.style.display = "flex";
                        }

                        if (limit.startPeriod != null && limit.endPeriod != null) {
                          if (limit.cumulativeLimitValue == null) {
                              limit.cumulativeLimitValue = "00:00:00";
                          }
                          this.dailyRolloverPeriod.nativeElement.style.display = "flex";
                          this.dailyRolloverPeriodContent.nativeElement.innerHTML = this.dateFormatPipe.transform(limit.startPeriod, config) + " TO  <br>"
                          + this.dateFormatPipe.transform(limit.endPeriod, config);

                          this.dailyTimeAmountUsed.nativeElement.style.display = "flex";
                          this.dailyTimeAmountUsedContent.nativeElement.innerHTML = limit.cumulativeLimitValue;
                      }

                      if (limit.newLimit && limit.endPeriod) {
                        this.timeDailyDelete.nativeElement.style.display = "none";
                        this.dailyNewLimitEffective.nativeElement.style.display = "flex";
                        this.dailyNewLimitEffectiveContent.nativeElement.innerHTML =
                            this.dateFormatPipe.transform(limit.endPeriod, config);
                            this.dailyRemoved.nativeElement.style.display = "none";
                            this.dailyPendingLimitContent.nativeElement.innerHTML = this.minutesToTime(limit.newLimit);
                            this.dailyPendingLimit.nativeElement.style.display = "flex";
                      }

                      if (limit.currentLimit && limit.endPeriod) {
                        this.dailyRemoved.nativeElement.style.display = "flex";
                        this.dailyRemovedContent.nativeElement.innerHTML =
                            this.dateFormatPipe.transform(limit.endPeriod, config);
                      }

                      if (!limit.newLimit && limit.deleteFlag) {
                        this.timeLimitForm.get('daily_limit').setValue("");
                        this.timeDailyDelete.nativeElement.style.display = "none";
                        this.dailyPendingLimit.nativeElement.style.display = "none";
                        this.dailyRemoved.nativeElement.style.display = "flex";
                        this.dailyRemovedContent.nativeElement.innerHTML = this.dateFormatPipe.transform(limit.endPeriod, config);
                    }

                    if (!limit.deleteFlag) {
                      this.dailyRemoved.nativeElement.style.display = "none";
                    }

                    if (!limit.newLimit || limit.newLimit < limit.currentLimit) {
                      this.dailyPendingLimit.nativeElement.style.display = "none";
                      this.dailyNewLimitEffective.nativeElement.style.display = "none";
                    }
                        break;

                    case "WEEKLY":
                        if (limit.currentLimit) {
                            this.currentWeeklyLimit.nativeElement.innerHTML = this.minutesToTime(limit.currentLimit);
                            this.timeWeeklyDelete.nativeElement.style.display = "flex";
                        }

                        if (limit.startPeriod != null && limit.endPeriod != null) {
                          if (limit.cumulativeLimitValue == null) {
                              limit.cumulativeLimitValue = "00:00:00";
                          }
                          this.weeklyRolloverPeriod.nativeElement.style.display = "flex";
                          this.weeklyRolloverPeriodContent.nativeElement.innerHTML = this.dateFormatPipe.transform(limit.startPeriod, config) + " TO  <br>"
                          + this.dateFormatPipe.transform(limit.endPeriod, config);

                          this.weeklyTimeAmountUsed.nativeElement.style.display = "flex";
                          this.weeklyTimeAmountUsedContent.nativeElement.innerHTML = limit.cumulativeLimitValue;
                      }

                      if (limit.newLimit && limit.endPeriod) {
                        this.timeWeeklyDelete.nativeElement.style.display = "none";
                        this.weeklyNewLimitEffective.nativeElement.style.display = "flex";
                        this.weeklyNewLimitEffectiveContent.nativeElement.innerHTML =
                            this.dateFormatPipe.transform(limit.endPeriod, config);
                            this.weeklyRemoved.nativeElement.style.display = "none";
                            this.weeklyPendingLimitContent.nativeElement.innerHTML = this.minutesToTime(limit.newLimit);
                            this.weeklyPendingLimit.nativeElement.style.display = "flex";
                      }

                      if (limit.currentLimit && limit.endPeriod) {
                        this.weeklyRemoved.nativeElement.style.display = "flex";
                        this.weeklyRemovedContent.nativeElement.innerHTML =
                            this.dateFormatPipe.transform(limit.endPeriod, config);
                      }

                      if (!limit.newLimit && limit.deleteFlag ) {
                        this.timeLimitForm.get('weekly_limit').setValue("");
                        this.timeWeeklyDelete.nativeElement.style.display = "none";
                        this.weeklyPendingLimit.nativeElement.style.display = "none";
                        this.weeklyRemoved.nativeElement.style.display = "flex";
                        this.weeklyRemovedContent.nativeElement.innerHTML = this.dateFormatPipe.transform(limit.endPeriod, config);
                    }

                    if (!limit.deleteFlag) {
                      this.weeklyRemoved.nativeElement.style.display = "none";
                    }

                    if (!limit.newLimit || limit.newLimit < limit.currentLimit) {
                      this.weeklyPendingLimit.nativeElement.style.display = "none";
                      this.weeklyNewLimitEffective.nativeElement.style.display = "none";
                    }
                        break;

                    case "MONTHLY":
                        if (limit.currentLimit) {
                            this.currentMonthlyLimit.nativeElement.innerHTML = this.minutesToTime(limit.currentLimit);
                            this.timeMonthlyDelete.nativeElement.style.display = "flex";
                        }

                        if (limit.startPeriod != null && limit.endPeriod != null) {
                          if (limit.cumulativeLimitValue == null) {
                              limit.cumulativeLimitValue = "00:00:00";
                          }
                          this.monthlyRolloverPeriod.nativeElement.style.display = "flex";
                          this.monthlyRolloverPeriodContent.nativeElement.innerHTML = this.dateFormatPipe.transform(limit.startPeriod, config) + " TO  <br>"
                          + this.dateFormatPipe.transform(limit.endPeriod, config);

                          this.monthlyTimeAmountUsed.nativeElement.style.display = "flex";
                          this.monthlyTimeAmountUsedContent.nativeElement.innerHTML = limit.cumulativeLimitValue;
                      }

                      if (limit.newLimit && limit.endPeriod) {
                        this.timeMonthlyDelete.nativeElement.style.display = "none";
                        this.monthlyNewLimitEffective.nativeElement.style.display = "flex";
                        this.monthlyNewLimitEffectiveContent.nativeElement.innerHTML =
                            this.dateFormatPipe.transform(limit.endPeriod, config);
                            this.monthlyRemoved.nativeElement.style.display = "none";
                            this.monthlyPendingLimitContent.nativeElement.innerHTML = this.minutesToTime(limit.newLimit);
                            this.monthlyPendingLimit.nativeElement.style.display = "flex";
                      }

                      if (limit.currentLimit && limit.endPeriod) {
                        this.monthlyRemoved.nativeElement.style.display = "flex";
                        this.monthlyRemovedContent.nativeElement.innerHTML =
                            this.dateFormatPipe.transform(limit.endPeriod, config);
                      }

                      if (!limit.newLimit && limit.deleteFlag) {
                        this.timeLimitForm.get('monthly_limit').setValue("");
                        this.timeMonthlyDelete.nativeElement.style.display = "none";
                        this.monthlyPendingLimit.nativeElement.style.display = "none";
                        this.monthlyRemoved.nativeElement.style.display = "flex";
                        this.monthlyRemovedContent.nativeElement.innerHTML = this.dateFormatPipe.transform(limit.endPeriod, config);
                    }

                    if (!limit.deleteFlag) {
                      this.monthlyRemoved.nativeElement.style.display = "none";
                    }

                    if (!limit.newLimit || limit.newLimit < limit.currentLimit) {
                      this.monthlyPendingLimit.nativeElement.style.display = "none";
                      this.monthlyNewLimitEffective.nativeElement.style.display = "none";
                    }
                        break;
                }
            }
        });
    }

    deleteLimit(event: Event, term: string) {
        event.preventDefault();

        this.successMessageProvider.clearMessage();
        this.error = null;

        const requestObj: any = {};
        requestObj.termType = term.toUpperCase();

        this.responsibleGamingProvider.deleteTimeLimit(requestObj).subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.getTotalLoginTime();
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    getTimeInMinutes(time: string) {
      return time?.split(':').map(Number).reduce((acc, curr) => acc * 60 + curr, 0);
    }

    setLimits( ) {
        this.successMessageProvider.clearMessage();
        this.error = null;

        const dailyLimit = this.timeLimitForm.get('daily_limit').value;
        const weeklyLimit = this.timeLimitForm.get('weekly_limit').value;
        const monthlyLimit = this.timeLimitForm.get('monthly_limit').value;
        const dailyLimitInMinutes = this.getTimeInMinutes(dailyLimit);
        const weeklyLimitInMinutes = this.getTimeInMinutes(weeklyLimit);
        const monthlyLimitInMinutes = this.getTimeInMinutes(monthlyLimit);

        const requestObj: any = {
          daily: dailyLimitInMinutes,
          weekly: weeklyLimitInMinutes,
          monthly: monthlyLimitInMinutes
        }
        this.responsibleGamingProvider.setTimeLimit(requestObj).subscribe({
            next: (response: any) => {
                if (response && !!response.result ) {
                    this.getTotalLoginTime();
                    this.timeLimitForm.get('daily_limit').setValue("");
                    this.timeLimitForm.get('weekly_limit').setValue("");
                    this.timeLimitForm.get('monthly_limit').setValue("");
                    this.successMessageProvider.setMessage('Your time limit was set.');
                    this.content.scrollToTop(10);
                }
            },
            error: (error) => {

                switch (error.getErrorCode().toUpperCase()) {
                    case 'INVALID_TERM_TYPE':
                        error.setErrorMessage('Limit cannot be 0!');
                        break;
                    default:
                        error.setErrorMessage('');
                        break;
                }
                this.error = error;
                this.content.scrollToTop();
            }
        });
    }

    // dailyLimitChanged() {
    //     if (this.globalDailyLimit != null) {
    //         if (parseInt(this.time_limit.value) > parseInt(this.globalDailyLimit.currentLimit)) {
    //             this.timeNewLimitError.nativeElement.style.display = "flex";
    //         }
    //         else {
    //             this.timeNewLimitError.nativeElement.style.display = "none";
    //         }
    //     }
    // }

    atLeastOneFieldValidator(group: FormGroup): {[key: string]: any} {
        let isAtLeastOne = false;
        if (group && group.controls) {
            for (const control in group.controls) {
                if (Object.prototype.hasOwnProperty.call(group.controls, control) && group.controls[control].valid && group.controls[control].value) {
                    isAtLeastOne = true;
                    break;
                }
            }
        }
        return isAtLeastOne ? null : { 'required': true };
    }

    onClose = () =>{
        this.limitsService.onCloseCommon(this.previousPage == "SignupResult");
    }

    onLimitInput(event: any, controlName: string) {
        const control = this.timeLimitForm.get(controlName);
        let value = event.target.value;

        if (/^\d+$/.test(value)) {
            const minutes = parseInt(value);
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            value = `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
            control.setValue(value, { emitEvent: false });
        }
    }
}
